import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/joget': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M227.5 468.7C218.5 455.1 207.6 435.4 203.8 426.3 198.1 412.6 176.6 380.7 235 359.2 286.7 340.1 411.7 342.7 443.8 341.6 439.8 350.6 435.2 359.5 429.9 368.2 389.5 433.7 319.5 469.7 247.9 469.7 241.1 469.7 234.3 469.3 227.5 468.7M66.1 143.9C128 43.4 259.6 12.2 360.1 74.1 434.9 120.2 471.3 205 459.4 286.8 434.5 286.3 280.1 283.2 229.1 281.9 173.6 280.5 147.4 261.1 170.6 233.7 193.8 206.3 221.7 193 239.5 182.5 257.4 172 266.8 148.8 215.9 152.8 87.3 161.5 48.6 252.1 37.6 293 28.8 243.3 37.5 190.3 66.1 143.9M36.9 125.9C-35 242.5 1.3 395.2 117.9 467.1 234.5 539 387.2 502.7 459.1 386.2 531 269.6 494.7 116.8 378.1 45 337.6 19.9 292.6 8 248.2 8 165 8 83.8 49.9 36.9 125.9M281.3 236.3C249.8 256.8 216 267.6 216 267.6L385.5 266 432 242.6S435.6 233.1 412.9 227.1C390.2 221.1 355.9 238.4 326.2 254.3 296.5 270.1 295.1 262.5 295.1 262.5S335.3 234.4 345.8 228C356.3 221.6 377.7 214 359.2 203.4 356 201.6 352.5 200.7 348.8 200.7 331 200.7 307.3 219.4 281.3 236.3'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/joget.js
// module id = ArGE
// module chunks = 144